import { useState, useEffect } from "react";
import ProgressBar from "src/components-v2/ProgressBar";

function ProgressLoading(props) {
  const { duration, color, ...rest } = props;
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const timer = progress < 100 && setInterval(() => setProgress(progress + 1), duration || 50);
    return () => clearInterval(timer);
  }, [progress]);

  return (
    <div className="u-w-1/3 u-mr-2" data-testid="qa-file-input-progress-loading">
      <ProgressBar color={color || "orange"} percent={progress} {...rest} />
    </div>
  );
}

export default ProgressLoading;
